/*
* Pipeline Theme
*
* Custom JavaScript for Pipeline.
* The custom.js import must be enabled in layout/theme.liquid.
*/

(function () {

  document.addEventListener('theme:variant:change', function (event) {
    var variant = event.detail.variant;
    var container = event.target;

    if (variant) {
      console.log('Container ———————— ↓');
      console.log(container);
      console.log('Variant —————————— ↓');
      console.log(variant);
    }
  });

  document.addEventListener('theme:cart:change', function (event) {
    var cart = event.detail.cart;

    if (cart) {
      console.log('Cart ———————————— ↓');
      console.log(cart);
    }
  });

  document.addEventListener('theme:cart:init', function (event) {
    console.log('theme:cart:init');
    console.log(event);
  });

  document.addEventListener('theme:scroll', function (event) {
    console.log(event);
  });

  document.addEventListener('theme:scroll:up', function (event) {
    console.log(event);
  });

  document.addEventListener('theme:scroll:down', function (event) {
    console.log(event);
  });

  document.addEventListener('theme:resize', function (event) {
    console.log(event);
  });


  // Automatically add In stock when another filter is selected.

  function initialiseInStockFilter() {
    let redirecting = false;
    let lastUrl = window.location.href;

    function ensureInStockFilter() {
      if (redirecting) return;

      const url = new URL(window.location.href);
      const params = url.searchParams;

      // Run only on collection and search pages.
      const isFilterPage =
        /\/collections\/[^/]+\/?$/.test(url.pathname) ||
        /\/search\/?$/.test(url.pathname);

      if (!isFilterPage) return;

      // Detect size, fit, colour, price and other filters.
      const hasOtherFilters = Array.from(params.entries()).some(
        function (entry) {
          const key = entry[0];
          const value = entry[1];

          return (
            key !== 'filter.v.availability' &&
            (
              key.startsWith('filter.v.') ||
              key.startsWith('filter.p.')
            ) &&
            value.trim() !== ''
          );
        }
      );

      // Preserve an existing availability selection.
      if (
        hasOtherFilters &&
        !params.has('filter.v.availability')
      ) {
        params.set('filter.v.availability', '1');
        params.delete('page');

        redirecting = true;

        window.location.replace(
          url.pathname + '?' + params.toString() + url.hash
        );
      }
    }

    function checkForUrlChange() {
      if (window.location.href !== lastUrl) {
        lastUrl = window.location.href;
        ensureInStockFilter();
      }
    }

    // Watch URL updates from Pipeline's filters.
    ['pushState', 'replaceState'].forEach(function (method) {
      const original = window.history[method];

      window.history[method] = function () {
        const result = original.apply(this, arguments);

        window.setTimeout(checkForUrlChange, 0);

        return result;
      };
    });

    // Watch browser back and forward navigation.
    window.addEventListener('popstate', checkForUrlChange);

    // Fallback when the theme updates the filter results.
    new MutationObserver(checkForUrlChange).observe(
      document.body,
      {
        childList: true,
        subtree: true
      }
    );

    // Check filters already present when the page opens.
    ensureInStockFilter();
  }

  // Start whether the file loads before or after DOMContentLoaded.
  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initialiseInStockFilter,
      { once: true }
    );
  } else {
    initialiseInStockFilter();
  }

})();